module.exports = __webpack_public_path__ + "static/media/mark-expectations-mobile.037ebb3d.png";